'use client';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
export { Autoplay, EffectFade, Pagination, Swiper, SwiperSlide };
